import ForkLeftOutlined from "@mui/icons-material/ForkLeftOutlined"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { Position } from "reactflow"

import Column from "../../../../../../common/components/Column"
import CustomHandle from "../../CustomHandle"
import { getEditorData } from "../../utils"
import BaseNode, { GreenNodeLabel, NodeContentLayout } from "../BaseNode"
import YesNoSplitNodeEditor from "./Editor"

export default function YesNoSplitNode(node) {
  const [editorOpen, setEditorOpen] = useState(false)
  const editorData = getEditorData(node)

  return (
    <>
      <BaseNode
        node={node}
        rootProps={{ onClick: () => setEditorOpen(true), sx: { pb: 1 } }}
      >
        <CustomHandle
          id="top-handle"
          type="target"
          position={Position.Top}
          node={node}
        />
        <GreenNodeLabel label="Action" />
        <NodeContentLayout
          title={node.data.label}
          subtitle={`Matches ${editorData.conditionFieldsState.length} Criteria`}
          Icon={ForkLeftOutlined}
        />
        <TitledHandle title="Yes" id="yes" left="20%" node={node} />
        <TitledHandle title="No" id="no" left="70%" node={node} />
      </BaseNode>
      <YesNoSplitNodeEditor
        open={editorOpen}
        onClose={() => setEditorOpen(false)}
        node={node}
      />
    </>
  )
}

function TitledHandle({ title, id, left, node }) {
  return (
    <Column
      sx={{
        alignItems: "center",
        textAlign: "center",
        position: "absolute",
        bottom: 0,
        left,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: (theme) => theme.palette.colors.gray700,
          fontWeight: 600,
          fontSize: "11px",
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <CustomHandle
        id={id}
        type="source"
        position={Position.Bottom}
        node={node}
      />
    </Column>
  )
}
